import { render, staticRenderFns } from "./complaint-list.vue?vue&type=template&id=3601f85b"
import script from "./complaint-list.vue?vue&type=script&lang=js"
export * from "./complaint-list.vue?vue&type=script&lang=js"
import style0 from "./complaint-list.vue?vue&type=style&index=0&id=3601f85b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports